/**
 * Side-effect entry: run before App.jsx is evaluated so initial route never uses username "feedback".
 */
import { canonicalizeMisroutedFeedbackPath } from './canonicalizeMisroutedFeedbackPath.js';

canonicalizeMisroutedFeedbackPath();
